import * as React from 'react'
import * as st from './toggleFollowingButton.module.scss'
import { ToggleFollowingAction, ToggleFollowingTag, ToggleFollowingScope, ToggleFollowingInput, ToggleFollowingOutput, WPSClient, Args, safeBool } from '@utils'
import * as cn from 'classnames'

export type ToggleFollowingButtonType = 'primary' | 'secondary' | 'undo-link'

export type ToggleFollowingButtonProps = ToggleFollowingAction & Args & {
    onSuccess?: (res: ToggleFollowingOutput) => void;
    onFailureWithMessage?: (res: ToggleFollowingOutput) => void;
    onUnexpectedFailure?: (error: any) => void;
    buttonType?: ToggleFollowingButtonType;
    className?: string;
}
export class ToggleFollowingButton extends React.Component<ToggleFollowingButtonProps> {
    constructor(props: ToggleFollowingButtonProps) {
        super(props)
    }

    constructInput = (newProps: ToggleFollowingButtonProps): ToggleFollowingInput => {
        const { endpoint, context } = newProps
        const { query } = endpoint
        const { tagValue, scopeValue, personIdValue, tokenValue, personNameValue } = this.getQueryValues(query)

        return {
            context,
            personId: personIdValue,
            personName: personNameValue,
            tag: tagValue as ToggleFollowingTag,
            scope: scopeValue as ToggleFollowingScope,
            token: tokenValue
        }
    }

    onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        this.submitForm()
    }

    submitForm = () => {
        const { logger, onSuccess, onFailureWithMessage, onUnexpectedFailure } = this.props

        new WPSClient().ToggleFollowing(this.constructInput(this.props))
            .then(res => {
                if (safeBool(res.success)) {
                    onSuccess && onSuccess(res)
                } else {
                    if (onFailureWithMessage) {
                        onFailureWithMessage(res)
                    } else {
                        throw new Error(res.message)
                    }
                }
            })
            .catch(err => {
                onUnexpectedFailure && onUnexpectedFailure(err)
                logger.error(err)
            })
    }

    getQueryValues = (query: {[key: string]: string;}) => {
        return {
            tagValue: query['tag'],
            scopeValue: query['scope'],
            personIdValue: query['personId'],
            tokenValue: query['token'],
            personNameValue: query['personName']
        }
    }

    getButtonStyle = (buttonType: ToggleFollowingButtonType, isFollowing: boolean) => {
        const defaultValue = isFollowing ? st.darkButton : st.lightButton
        switch(buttonType) {
            case 'primary':
                return defaultValue
            case 'secondary':
                return st.lightButton
            case 'undo-link':
                return st.linkButton
            default:
                return defaultValue
         }
    }

    render() {
        const { tag, buttonType, text, endpoint, className } = this.props
        const isFollowing = tag === ToggleFollowingTag.Unfollow
        const { partialURL, query } = endpoint
        const { tagValue, scopeValue, personIdValue, tokenValue, personNameValue } = this.getQueryValues(query)

        const buttonStyle = this.getButtonStyle(buttonType || 'primary', isFollowing)
        const formClassName = cn(st.toggleFollowingButton, {
            [className]: className
        })

        return <form action={partialURL} method="POST" onSubmit={this.onSubmit} className={formClassName}>
            <input name="token" type="hidden" value={tokenValue}/>
            <input name="tag" type="hidden" value={tagValue}/>
            <input name="scope" type="hidden" value={scopeValue}/>
            <input name="personId" type="hidden" value={personIdValue}/>
            { personNameValue && <input name="personName" type="hidden" value={personNameValue}/> }
            <button type="submit" className={buttonStyle}>{text}</button>
        </form>
    }
}
